import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { recentBuyers, images } from "../data/content";
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const INTERVAL = 14000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setIndex(Math.floor(Math.random() * recentBuyers.length));
      setMinutesAgo(Math.floor(Math.random() * 9) + 1);
      setOpen(true);
      hideTimer = window.setTimeout(() => setOpen(false), VISIBLE_FOR);
    };
    const first = window.setTimeout(show, FIRST_DELAY);
    const loop = window.setInterval(show, INTERVAL);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <AnimatePresence data-id="element-48" data-mp="1164p8a24l03x">
      {open && !dismissed && <motion.div role="status" initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-[96px] left-3 right-3 z-50 flex items-center gap-3 rounded-2xl border border-line bg-white p-3 pr-9 shadow-[0_16px_40px_-12px_rgba(10,27,51,0.45)] md:bottom-6 md:left-6 md:right-auto md:w-[360px]" data-id="element-49" data-mp="1fviyli5pbhjb">
          <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-paper object-contain" data-id="element-50" data-mp="s5okyydk5oy0" />
          <div className="min-w-0" data-id="element-51" data-mp="28mkhnucilx84">
            <p className="text-sm leading-snug text-ink" data-id="element-52" data-mp="23lmxxdbuwv4i">
              <span className="font-bold" data-id="element-53" data-mp="23l3ettah00ow">{buyer.name}</span> from <span className="font-bold" data-id="element-54" data-mp="2apcrmzy5v1hx">{buyer.country}</span>
            </p>
            <p className="text-sm leading-snug text-muted" data-id="element-55" data-mp="2fne8de846oq8">just purchased Shoulder Assessment Blueprint™</p>
            <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-good" data-id="element-56" data-mp="2km7oleesctu3">
              <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-57" data-mp="2plk8bqad1ksg" />
              {minutesAgo} min ago
            </p>
          </div>
          <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-muted hover:bg-paper hover:text-ink" aria-label="Close notification" data-id="element-58" data-mp="1rzei0fept0c6">
            <XIcon className="h-4 w-4" data-id="element-59" data-mp="26mzomjasthou" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}